
<template>
  <div style="height: 100%;">
      <el-row type="flex" align="middle" justify="center">
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" >
          <el-card shadow="never" class="card">
            <div slot="header" class="clearfix">
                <img src="/static/logo.png" />
              </div>
              <el-row>
                
                <div class="card-content-title-img">
                  <i class="fas fa-ban"></i>
                  <i class="fas fa-envelope-open-text"></i>
                </div>
                <div class="card-content-title">INSUNET FC 이메일 수신거부 신청 페이지입니다.</div>
                <el-divider></el-divider>
                <div class="card-content-subtitle">
                  <span class="sender">{{recv ? recv : ''}}</span>
                  로 발송되는 이메일을 
                  <span class="highlight">수신거부</span>
                  하시겠습니까?
                </div>
              </el-row>
              <el-row>
                <div class="card-content-main">
                  <el-switch
                      v-model="val"
                      active-text="(수신거부)"
                      inactive-text="(수신거부 해제)"
                      active-color="#13ce66"
                      size="default" @change="submit">
                    </el-switch>
                </div>
                <el-divider></el-divider>
                <el-row v-if="rst && val" class="comp-text">
                  이메일 수신거부 설정이 완료되었습니다.
                </el-row>
                <el-row v-else-if="rst && !val" class="comp-text">
                  이메일 수신거부 해제 설정이 완료되었습니다.
                </el-row>
              
              
              </el-row>
            </el-card>
        </el-col>
      </el-row>
      
  </div>
</template>

<script>
import { Card, Avatar, Switch, Row, Col ,Divider, Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

export default {
  components: { [Card.name]: Card,[Avatar.name]: Avatar,[Switch.name]: Switch,[Row.name]: Row,[Col.name]: Col, [Divider.name]: Divider},
  data(){
     return {
        val: false,
        rst: false,
        token_data: null,
        token: null,
        recv: null,
        id: null,
    }
  },
  created() {
    console.log(this.$route)
    this.id = this.$route.query.id
    if(this.$route.query.recv) this.recv = this.$route.query.recv
    if(this.$route.query.email) this.recv = this.$route.query.email

    /*if(!this.$route.query.token) {
      this.$router.push({name: "Home"})
    }
    this.token = this.$route.query.token
    var jwtDecode = require('jwt-decode');
    this.token_data = jwtDecode(this.token);
    console.log(this.token_data);*/
  },
  mounted() {

  },
  methods: {
    submit() {
       this.axios.put(`${this.$store.state.config.hostName}/v1/www/customer.email/deny/${this.id}`, { "emaildeny": this.val ? "1" : "0", "email": this.recv } )
       .then( res => {
         if(res.data.status != "success"){
           Message({
            message: res.data.error,
            type: 'error'
          })
         }else{
           this.rst = true
         }
        }).catch( e => {
          this.rst = false
          Message({
            message: e,
            type: 'error'
          })
        });
    }
  }
}
</script>

<style lang="scss">
html, body , #site-wrapper {
  height: 100%;
}
span.el-switch__label > span {
  font-weight: bold;
  font-size: 18px !important;
}
span.el-switch__label.el-switch__label--left {
    position: absolute;
    left: -127px;
    top: 1px;
}
span.el-switch__label.el-switch__label--right {
    position: absolute;
    right: -87px;
    top: 1px;
}
span.el-switch__label.is-active > span {
  color: #174de5;
}
.el-row, .el-col {
  position: relative;
}
.el-row {
  height: 100%;
}
</style>
<style lang="scss" scoped>
.card-content-title-img {
  position: relative;
  height: 100px;
  & > i.fa-ban {
    position: absolute;
    right: 0;
    left: 0;
    margin: auto;
    font-size: 100px;
    width: 100px;
    height: 100px;
    z-index: 1;
    color: #cc2b2b;
  }
  & > i.fa-envelope-open-text {
    position: absolute;
    right: 0;
    left: 0;
    margin: auto;
    font-size: 45px;
    width: 45px;
    height: 45px;
    top: -5px;
    bottom: 0;
    color: #2d395d;
  }
}
.card-content-title{
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  padding: 1.5rem;
}
.card-content-subtitle{
  font-size: 20px;
  /* font-weight: bold; */
  text-align: center;
  padding: 1.5rem;
  color: #676767;
}
.card-content-main {
  text-align: center;
}
.comp-text.el-row {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    color: #174de5;
}


.card {
    width: 100%;
    height: 590px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 100;
    bottom: 0;
    left: 0;
    margin: auto;
}
.flex {
  display: flex;
  flex-direction: row;
}
.flex .left{
  flex: 0 0 auto;
}
.left.img {
  position: relative;
  width: 40px;
  height: 48px;
  margin: 0 10px 0 0;
}
span.el-avatar.el-avatar--circle {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}
.flex .right {
  flex: 1;
}
.label {
  font-size: 15px;
  font-weight: bold;
}
.sender{
color: #174de5;
  font-weight: bold;
text-decoration: underline;
text-underline-position: under;
}
.highlight {
  font-weight: bold;
  color: black;
}
</style>